import { DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { formatUTCTime } from "../../../global/utils/unixToLocalTime";
import { getGiftCardRowId } from "../utils/rowId";

export const PrepurchasedLicenseColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params,
  _hideColmn,
) => {
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {};

  return [
    {
      title: "No",
      dataIndex: "GiftCardNo",
      key: "GiftCardNo",
      sorter: (a, b) => Number(getGiftCardRowId(a)) - Number(getGiftCardRowId(b)),
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="GiftCardNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "GiftCardNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      render: (_, record) => getGiftCardRowId(record),
    },
    {
      title: "Name",
      dataIndex: "GiftCardName",
      key: "GiftCardName",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="GiftCardName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "GiftCardName",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Description",
      dataIndex: "GiftCardDesc",
      key: "GiftCardDesc",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="GiftCardDesc"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "GiftCardDesc",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Price"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Price",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      render: (value) => (value ? `$ ${value}` : null),
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex && record?.Paid === "No" ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Edit">
                <div className="hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] mr-1 ">
                  <Link
                    to={`/prepurchased-license/edit/${getGiftCardRowId(record)}`}
                    onClick={(e) => e.stopPropagation()}
                    className=" hover:text-[#636262ee]"
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="!text-[#50565e]"
                    />
                  </Link>
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([getGiftCardRowId(record)]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
